export default "__VITE_ASSET__B5nY1bw0__"